/**
 * Handles storage provider change for a specific file item.
 * Mutates the item directly — triggers notify so thumbnail list updates provider label.
 */
export default class OnProviderChangedHandler {

    /**
     * @param {object} state - shared upload state from UploadAttachmentHandler
     */
    constructor(state) {
        this._state = state;
    }

    /**
     * @param {{ index: number, value: string }} data
     */
    handle({ index, value }) {
        const item = this._state.files[index];
        if (!item) return;
        item.provider = value;
    }
}
